// Structured company profile content derived from provided PDF text
// Keeping naming conventions consistent and using a single export for DRY usage across sections
export const companyProfile = {
  companyOverview: {
    establishedYear: 1998,
    name: 'ANR Mechanical Corp.',
    summary:
      'ANR Mechanical Corp. is a full-service mechanical contractor specializing in HVAC design, building, and installation. We provide complete turn-key solutions—from piping and ductwork to final commissioning—ensuring systems are efficient, compliant, and built to specification.'
  },
  coreCompetencies: [
    {
      title: 'HVAC Design & Build',
      description:
        'Complete system design and installation for new construction and retrofits.'
    },
    {
      title: 'Mechanical Piping & Ductwork',
      description:
        'Fabrication and installation of all required piping and sheet metal ductwork.'
    },
    {
      title: 'Specialized Equipment',
      description:
        'Installation of chillers, boilers, cooling towers, and generator cooling systems.'
    },
    {
      title: 'Systems Integration',
      description:
        'HVAC controls, insulation, and complete commissioning of A/C systems.'
    },
    {
      title: 'Critical Environments',
      description:
        'Climate control for computer rooms and high-demand commercial spaces.'
    }
  ],
  pastPerformance: [
    'State & Federal Government Offices',
    'Hospitals and Medical Facilities',
    'Courthouses',
    'Commercial Buildings',
    'Retail Stores',
    'Educational Institutions',
    'High-Rise Residential',
    'Restaurants'
  ],
  differentiators: [
    'Established expertise since 1998 with deep industry knowledge.',
    'High bonding capacity: $5 Million (Single) / $10 Million (Aggregate).',
    'Certified personnel: All employees are OSHA certified and trained.',
    'Diverse portfolio in high-stakes environments including hospitals and federal offices.'
  ],
  identifiers: {
    federalId: '11-3424601',
    dolNo: '25-64CFQ-CR',
    dunsNo: '809223667'
  },
  contact: {
    address: '1906 Stewart Ave, New Hyde Park, NY 11040',
    phone: '(516) 414-0165',
    fax: '(516) 414-0166',
    email: 'anil@anrmechanical.com',
    website: 'www.anrmechanical.com',
    president: 'Anil Roy'
  },
  naicsCodes: [
    { code: '238220', label: 'HVAC General' },
    { code: '423730', label: 'HVAC Equipment & Supplies' }
  ],
  certifications: [
    'Port Authority NY/NJ: MBE Certified',
    'NYS File ID: 48927',
    'NYC MBE Certificate: MWCERT-2685',
    'NYS DOL Certificate of Contractor Registration'
  ],
  keyClients: [
    'Shawmut',
    'Procida',
    'Volmar Construction',
    'Sheela Inc.',
    'Integrated Construction Group',
    'Trinity Construction',
    'OGS NYS',
    'Bolivar Construction Group'
  ]
};